module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Medium.woff2
// module id = 272
// module chunks = 0